import analytics from '@utils/analytics';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@common/utils/api';
const SearchSuggested = (props) => {
    const { t } = useTranslation();
    const [suggested, setSuggested] = useState();
    useEffect(() => {
        let isSubscribed = true;
        api.getSuggestions(true).then((data) => {
            if (!data.error) {
                isSubscribed ? setSuggested(data) : null;
            }
        });
        return () => {
            isSubscribed = false;
        };
    }, []);
    return suggested && (suggested.recent.available || suggested.suggestions.available || suggested.popular.available) ? (React.createElement(motion.div, { className: "suggested-container", initial: { y: -32, opacity: 0 }, animate: { y: 0, opacity: 1 }, transition: { ease: [0.25, 1, 0.5, 1], duration: 0.3 } },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                suggested.recent.available && (React.createElement("div", { className: "col-lg-2 col-md-3" },
                    React.createElement("h2", { className: "suggested-title" }, t('search.suggestion.recent')),
                    React.createElement("ul", { className: "suggested-list" }, suggested.recent.phrases.map((phrase, i) => {
                        return (React.createElement("li", { key: i },
                            React.createElement("button", { onClick: () => {
                                    analytics.suggestedSearchClick('recent', phrase.value);
                                    props.updateInputSearch(phrase.value);
                                    props.startSearch();
                                } }, phrase.value)));
                    })))),
                suggested.suggestions.available && (React.createElement("div", { className: "col-lg-2 col-md-3" + (!suggested.popular.available && !suggested.recent.available ? ' center-text' : '') },
                    React.createElement("h2", { className: "suggested-title" }, t('search.suggestion.products')),
                    React.createElement("ul", { className: "suggested-list" }, suggested.suggestions.products.map((product, i) => {
                        return (React.createElement("li", { key: i },
                            React.createElement("a", { href: product.url, onClick: () => analytics.suggestedSearchClick('suggestions', product.name) }, product.name)));
                    })))),
                suggested.popular.available && (React.createElement("div", { className: "col-lg-2 col-md-3" },
                    React.createElement("h2", { className: "suggested-title" }, t('search.suggestion.popular')),
                    React.createElement("ul", { className: "suggested-list" }, suggested.popular.phrases.map((phrase, i) => {
                        return (React.createElement("li", { key: i },
                            React.createElement("button", { onClick: () => {
                                    analytics.suggestedSearchClick('popular', phrase.value);
                                    props.updateInputSearch(phrase.value);
                                    props.startSearch();
                                } }, phrase.value)));
                    })))))))) : (React.createElement(React.Fragment, null));
};
export default SearchSuggested;
